import { render, staticRenderFns } from "./formProposta_p1.vue?vue&type=template&id=35ec8de6"
import script from "./formProposta_p1.vue?vue&type=script&lang=js"
export * from "./formProposta_p1.vue?vue&type=script&lang=js"
import style0 from "./formProposta_p1.vue?vue&type=style&index=0&id=35ec8de6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports